import React from 'react';
import { InputGroup, InputGroupAddon } from 'reactstrap';
import DatePicker from '@/components/customized/DatePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

export default ({date, onDayChange, disabled}) => (
  <InputGroup>
    <InputGroupAddon addonType="prepend">
      <span className="input-group-text">
        <FontAwesomeIcon icon={faCalendarAlt} />
      </span>
    </InputGroupAddon>
    <DatePicker date={date} onDayChange={onDayChange} disabled={disabled}/>
  </InputGroup>
)


// WEBPACK FOOTER //
// ./src/components/common/DatePicker.js